import {Component, Input} from '@angular/core';

import {DetailField, DetailParams} from '../../../../shared';
import {SUELOSCOREDETAIL_DEFAULT_FIELDS, SuelosCoreDetailParams} from '../../../models';

@Component({
  selector: 'app-suelo-detail',
  templateUrl: './suelo-detail.component.html',
  styleUrls: ['./suelo-detail.component.scss']
})
export class SueloDetailComponent {
  fields: DetailField[] = [];
  detailParams: DetailParams = null;

  constructor() {
  }

  _params: SuelosCoreDetailParams = null;

  @Input()
  set params(value: SuelosCoreDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }
    this.fields = value.fields || SUELOSCOREDETAIL_DEFAULT_FIELDS;
    const rows = this.fields.map(f => ({
      label: f.label,
      value: value.suelo[f.name]
    }));
    this.detailParams = {
      rows
    };
  }
}
